import React from 'react';
import PurpleTick from '../../../assets/images/purple-tick-icon.svg';
import OrangeTick from '../../../assets/images/orange-tick-icon.svg';
import { Box, Text } from '@wix/design-system';
import { Trans, useTranslation } from 'react-i18next';
import s from './Title.scss';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { Experiments, PurchaseMode } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';

const allPlansIncludeContent = [
  'premium-purchase-plan.header.fallback_feature.custom_domain',
  'premium-purchase-plan.header.fallback_feature.remove_branding',
  'premium-purchase-plan.header.fallback_feature.customer_care',
];

const newLowTierPlanContent = [
  'premium-plan-purchase.header.all_premium_plans_include.reliable_web_hosting',
  'premium-plan-purchase.header.all_premium_plans_include.connect_domain',
  'premium-plan-purchase.header.all_premium_plans_include.customer_care',
];

const freeCouponsContent = [
  'premium-purchase-plan.header.all_plans_include.custom_domain_be_em',
  'premium-purchase-plan.header.all_plans_include.email_marketing_plan',
  'premium-purchase-plan.header.all_plans_include.social_media_marketing'
];

interface AllPlansIncludeProps {
  rootStore: RootStore;
}

export const AllPlansIncludeComp: React.FC<AllPlansIncludeProps> = ({
  rootStore,
}) => {
  const { t } = useTranslation();
  const { purchaseMode, isChangePlan } = usePageModeContext();
  const {
    appStore: { experiments },
  } = rootStore;
  let content = allPlansIncludeContent;
  if (experiments[Experiments.NewLowTierPlan] === 'true') {
    content = newLowTierPlanContent;
  } else if (
    experiments[Experiments.EnableImmediateCouponsDeliverySpec] === 'true'
  ) {
    content = freeCouponsContent;
  }

  let titleKey = 'premium-purchase-plan.header.all_premium_plans_include.title';
  if (experiments[Experiments.EnableImmediateCouponsDeliverySpec] === 'true') {
    titleKey =
      'premium-purchase-plan.header.all_plans_include.business_email_email_marketing_title';
  }

  const isReplaceChangePlanPurchaseModeEnabled =
    experiments[Experiments.ReplaceChangePlanPurchaseMode] === 'true';
  const isInChangePlan = isReplaceChangePlanPurchaseModeEnabled
    ? isChangePlan
    : purchaseMode === PurchaseMode.CHANGE_PLAN;
  const isUnifiedChangePlanPhase1Enabled =
    experiments[Experiments.UnifiedChangePlanPhase1] === 'true';

  const shouldShowPurpleTick = () => {
    if (purchaseMode === PurchaseMode.DEFAULT) {
      return true;
    }
    return isInChangePlan && !isUnifiedChangePlanPhase1Enabled;
  };

  return (
    <Box gap='SP4'>
      <Text className={s.semiBold}>
        <Trans
          i18nKey={titleKey}
          components={{
            b: <b />,
          }}
        />
        {/* {t(titleKey)} */}
      </Text>
      {content.map((contentItem) => (
        <Box verticalAlign='middle' gap='SP1' key={contentItem}>
          {shouldShowPurpleTick() ? <PurpleTick /> : <OrangeTick />}
          <Text className={s.semiBold}>{t(contentItem)}</Text>
        </Box>
      ))}
    </Box>
  );
};

export const AllPlansInclude = withInjectedRootStore(AllPlansIncludeComp);
